import { render, staticRenderFns } from "./CandidateNoteModal.html?vue&type=template&id=36ea17f2&scoped=true&external"
import script from "./CandidateNoteModal.js?vue&type=script&lang=js&external"
export * from "./CandidateNoteModal.js?vue&type=script&lang=js&external"
import style0 from "./CandidateNoteModal.scss?vue&type=style&index=0&id=36ea17f2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea17f2",
  null
  
)

export default component.exports